import "./cell-builder.sass";

function CellBuilder(prim, sec) {
  return (
    <div
      className={
        " cell-builder"
      }
    >
      
      <div>
        {prim && <div className="prim-text ">{prim}</div>}
        {sec && <div className="sec-text">{sec}</div>}
      </div>
    </div>
  );
}

export default CellBuilder;
